module.exports = __webpack_public_path__ + "img/shdl.f25df8ef.jpg";